module.exports = __webpack_public_path__ + "static/media/cancelada.45312540.svg";